




































































































































































































import _get from 'lodash/get'
import Component from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { getKehittamistoimenpiteet as getKehittamistoimenpiteetKouluttaja } from '@/api/kouluttaja'
import { getKehittamistoimenpiteet as getKehittamistoimenpiteetVastuuhenkilo } from '@/api/vastuuhenkilo'
import ElsaButton from '@/components/button/button.vue'
import ErikoistuvaDetails from '@/components/erikoistuva-details/erikoistuva-details.vue'
import ElsaFormError from '@/components/form-error/form-error.vue'
import ElsaFormGroup from '@/components/form-group/form-group.vue'
import KoejaksonVaiheHyvaksynnat from '@/components/koejakson-vaiheet/koejakson-vaihe-hyvaksynnat.vue'
import KoulutuspaikanArvioijat from '@/components/koejakson-vaiheet/koulutuspaikan-arvioijat.vue'
import ElsaConfirmationModal from '@/components/modal/confirmation-modal.vue'
import ElsaReturnToSenderModal from '@/components/modal/return-to-sender-modal.vue'
import store from '@/store'
import {
  KehittamistoimenpiteetLomake,
  KoejaksonVaiheButtonStates,
  KoejaksonVaiheHyvaksynta,
  KoejaksonVaihe
} from '@/types'
import { resolveRolePath } from '@/utils/apiRolePathResolver'
import { LomakeTilat, LomakeTyypit } from '@/utils/constants'
import { checkCurrentRouteAndRedirect } from '@/utils/functions'
import * as hyvaksynnatHelper from '@/utils/koejaksonVaiheHyvaksyntaMapper'
import { toastFail, toastSuccess } from '@/utils/toast'

@Component({
  components: {
    ErikoistuvaDetails,
    ElsaFormGroup,
    ElsaFormError,
    ElsaButton,
    ElsaConfirmationModal,
    ElsaReturnToSenderModal,
    KoulutuspaikanArvioijat,
    KoejaksonVaiheHyvaksynnat
  },
  validations: {
    kehittamistoimenpiteet: {
      kehittamistoimenpiteetRiittavat: {
        required
      }
    }
  }
})
export default class ArviointilomakeKehittamistoimenpiteet extends Mixins(validationMixin) {
  items = [
    {
      text: this.$t('etusivu'),
      to: { name: 'etusivu' }
    },
    {
      text: this.$t('koejakso'),
      to: { name: 'koejakso' }
    },
    {
      text: this.$t('kehittamistoimenpiteet-otsikko'),
      active: true
    }
  ]

  kehittamistoimenpiteidenArviointiOptions = [
    {
      text: this.$t('kehittamistoimenpiteet-riittavat'),
      value: true
    },
    {
      text: this.$t('kehittamistoimenpiteet-ei-riittavat'),
      value: false
    }
  ]

  buttonStates: KoejaksonVaiheButtonStates = {
    primaryButtonLoading: false,
    secondaryButtonLoading: false
  }

  loading = true

  kehittamistoimenpiteet: KehittamistoimenpiteetLomake | null = null

  validateState(value: string) {
    const form = this.$v.kehittamistoimenpiteet
    const { $dirty, $error } = _get(form, value) as any
    return $dirty ? ($error ? false : null) : null
  }

  get kehittamistoimenpiteetTila() {
    return store.getters[`${resolveRolePath()}/koejaksot`].find(
      (k: KoejaksonVaihe) =>
        k.id === this.kehittamistoimenpiteet?.id &&
        k.tyyppi === LomakeTyypit.KEHITTAMISTOIMENPITEET
    )?.tila
  }

  get kehittamistoimenpiteetId() {
    return Number(this.$route.params.id)
  }

  get editable() {
    if (
      this.kehittamistoimenpiteet?.lahiesimies.id ==
        this.kehittamistoimenpiteet?.lahikouluttaja.id &&
      !this.kehittamistoimenpiteet?.lahiesimies.sopimusHyvaksytty &&
      !this.kehittamistoimenpiteet?.lahikouluttaja.sopimusHyvaksytty
    ) {
      return true
    }
    return (
      (this.$isKouluttaja() || this.$isVastuuhenkilo()) &&
      !this.isCurrentUserLahiesimies &&
      !this.kehittamistoimenpiteet?.lahikouluttaja.sopimusHyvaksytty
    )
  }

  get editableForEsimies() {
    return (
      this.isCurrentUserLahiesimies &&
      this.kehittamistoimenpiteet?.lahikouluttaja.sopimusHyvaksytty &&
      !this.kehittamistoimenpiteet?.lahiesimies.sopimusHyvaksytty
    )
  }

  get isCurrentUserLahiesimies() {
    const currentUser = store.getters['auth/account']
    return this.kehittamistoimenpiteet?.lahiesimies.kayttajaUserId === currentUser.id
  }

  get erikoistuvanAvatar() {
    return this.kehittamistoimenpiteet?.erikoistuvanAvatar
  }

  get erikoistuvanNimi() {
    return this.kehittamistoimenpiteet?.erikoistuvanNimi
  }

  get waitingForLahiesimiesOrErikoistuva() {
    return (
      !this.isCurrentUserLahiesimies &&
      this.kehittamistoimenpiteet?.lahikouluttaja.sopimusHyvaksytty &&
      !this.kehittamistoimenpiteet?.lahiesimies.sopimusHyvaksytty
    )
  }

  get acceptedByEveryone() {
    return this.kehittamistoimenpiteet?.lahiesimies.sopimusHyvaksytty
  }

  get returned() {
    return this.kehittamistoimenpiteetTila === LomakeTilat.PALAUTETTU_KORJATTAVAKSI
  }

  get hyvaksynnat(): KoejaksonVaiheHyvaksynta[] {
    const hyvaksyntaErikoistuva = hyvaksynnatHelper.mapHyvaksyntaErikoistuva(
      this,
      this.kehittamistoimenpiteet?.erikoistuvanNimi,
      this.kehittamistoimenpiteet?.erikoistuvanKuittausaika
    ) as KoejaksonVaiheHyvaksynta
    const hyvaksyntaLahikouluttaja = hyvaksynnatHelper.mapHyvaksyntaLahikouluttaja(
      this,
      this.kehittamistoimenpiteet?.lahikouluttaja
    )
    const hyvaksyntaLahiesimies = hyvaksynnatHelper.mapHyvaksyntaLahiesimies(
      this,
      this.kehittamistoimenpiteet?.lahiesimies
    )

    return [hyvaksyntaLahikouluttaja, hyvaksyntaLahiesimies, hyvaksyntaErikoistuva].filter(
      (a): a is KoejaksonVaiheHyvaksynta => a !== null
    )
  }

  async onReturnToSender(korjausehdotus: string) {
    const form = {
      ...this.kehittamistoimenpiteet,
      korjausehdotus: korjausehdotus,
      lahetetty: false
    }

    try {
      this.buttonStates.secondaryButtonLoading = true
      await store.dispatch('kouluttaja/putKehittamistoimenpiteet', form)
      this.buttonStates.secondaryButtonLoading = false
      checkCurrentRouteAndRedirect(this.$router, '/koejakso')
      toastSuccess(this, this.$t('kehittamistoimenpiteet-palautus-onnistui'))
    } catch {
      toastFail(this, this.$t('kehittamistoimenpiteet-palautus-epaonnistui'))
    }
  }

  async onSign() {
    if (!this.kehittamistoimenpiteet) return
    try {
      this.buttonStates.primaryButtonLoading = true
      await store.dispatch('kouluttaja/putKehittamistoimenpiteet', this.kehittamistoimenpiteet)
      this.buttonStates.primaryButtonLoading = false
      checkCurrentRouteAndRedirect(this.$router, '/koejakso')
      toastSuccess(this, this.$t('kehittamistoimenpiteet-lahetys-onnistui'))
    } catch {
      toastFail(this, this.$t('kehittamistoimenpiteet-lahetys-epaonnistui'))
    }
  }

  naytaKehittamistoimenpideKategoria(kategoria: string, muuKategoria: string | null) {
    if (kategoria === 'MUU') return muuKategoria
    return this.$t('kehittamistoimenpidekategoria-' + kategoria)
  }

  onValidateAndConfirm() {
    if (!this.isCurrentUserLahiesimies) {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
    }
    return this.$bvModal.show('confirm-send')
  }

  async mounted() {
    this.loading = true
    await store.dispatch(`${resolveRolePath()}/getKoejaksot`)

    try {
      const { data } = await (this.$isVastuuhenkilo()
        ? getKehittamistoimenpiteetVastuuhenkilo(this.kehittamistoimenpiteetId)
        : getKehittamistoimenpiteetKouluttaja(this.kehittamistoimenpiteetId))
      this.kehittamistoimenpiteet = data
      this.loading = false
    } catch {
      toastFail(this, this.$t('kehittamistoimenpiteiden-hakeminen-epaonnistui'))
      this.$router.replace({ name: 'koejakso' })
    }
  }
}
